// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BehanceSquareOutlinedSvg from "@ant-design/icons-svg/es/asn/BehanceSquareOutlined";
import AntdIcon from '../components/AntdIcon';

var BehanceSquareOutlined = function BehanceSquareOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BehanceSquareOutlinedSvg
  }));
};

BehanceSquareOutlined.displayName = 'BehanceSquareOutlined';
export default React.forwardRef(BehanceSquareOutlined);